import React from "react";
import { FaPlus } from "react-icons/fa";

export const AddHabitCard: React.FC = () => {
  return (
    <div className="px-3 flex flex-col rounded-md bg-gray-100 w-full ">
      <div className="col-span-2 text-sm flex text-site-blue-dark p-1">
        <div
          style={{
            border: "2px solid rgb(1,59,120)",
            width: "22px",
            height: "22px",
            padding: "3px",
          }}
          className="mr-2 rounded-full flex justify-center items-center"
        >
          <FaPlus />
        </div>
        <span>Add new</span>
      </div>
    </div>
  );
};
